import { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";

import { Col, Row } from "react-bootstrap";
import editprofile from "../../assets/images/edit-profile.svg";
import circleredclose from "../../assets/images/close-circlered.svg";

import EditProfileForm from "../../components/Dashboard/EditProfileForm";
import useCurrentUser from "hooks/useCurrentUser";
import { userService, utilService } from "services";
import Loader from "components/Loader";
import deafultuserImg from "../../assets/images/avatar.svg";
import { formatPhoneNumber } from "utils";
import DeleteAccount from "components/Modals/Alertpopus/DeleteAccount";

const ClientProfile = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { user: currentUser, loading, setUser: setCurrentUser } = useCurrentUser();
  const [isLoading, setIsLoading] = useState(loading);
  const [isDelete, setIsDelete] = useState(false);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const extension = file.name.split('.').pop();

    try {
      setIsLoading(true);
      const response = await utilService.getBucketUrl({
        location: 'users/',
        extension
      })
      const webUrlData = response.data.data[0];
      const { filename, url } = webUrlData || {};

      const requestOptions = {
        method: 'PUT',
        headers: {
          "Content-Type": file.type
        },
        body: file,
        redirect: 'follow'
      };

      await utilService.uploadFile({
        url,
        requestOptions
      })
      const profile = await userService.updateProfilePicture({
        avatar: filename
      })
      setCurrentUser(profile?.data?.data);
      localStorage.setItem('userData', JSON.stringify(profile?.data?.data))
    }
    catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }


  return (
    <div className="container-box">
      <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white">
        <h2>Profile</h2>
      </div>
      <div className="outer-white position-relative">
        <Row>
          <Loader loading={isLoading} />
          <Col xl={12} lg={12}>
            <div className="profile-cards client-profile border-0">
              <div className="d-flex align-items-center box-profile">
                <div className="avatar-upload">
                  <div className="avatar-edit">
                    <input
                      type="file"
                      id="imageUpload"
                      accept=".png, .jpg, .jpeg"
                      onChange={handleFileUpload}
                    />
                    <label htmlFor="imageUpload" />
                  </div>
                  <div className="avatar-preview">
                    <div id="imagePreview">
                      <img
                        alt="User Avatar"
                        className="rounded-circle border border-secondary"
                        src={`${currentUser?.baseS3Url}${currentUser?.avatar || ""}`}
                        onError={(e) => {
                          e.currentTarget.onerror = null; // prevent infinite loop
                          e.currentTarget.src = deafultuserImg; // fallback avatar
                        }}
                      />
                    </div>
                  </div>
                </div>
                <p className="mb-0">{currentUser?.fullName}</p>
              </div>
              <div className="profie-heding py-1">
                <div className="d-flex justify-content-between align-items-center">
                  <h4>Personal Details</h4>
                  <div>
                    <img
                      src={editprofile}
                      className="cursor-pointer"
                      onClick={handleShow}
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <Row className="details-profiles">
                <Col lg={6}>
                  {" "}
                  <div className="mb-4">
                    <p className="light-text-profile">Business Name</p>
                    <p className="dark-profile-text">{currentUser?.businessName}</p>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-4">
                    <p className="light-text-profile">Email</p>
                    <p className="dark-profile-text">{currentUser?.email}</p>
                  </div>
                </Col>
                <Col lg={6}>
                  {" "}
                  <div className="mb-4">
                    <p className="light-text-profile">Mobile</p>
                    <p className="dark-profile-text">{formatPhoneNumber(currentUser?.formattedNumber)}
                    </p>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-4">
                    <p className="light-text-profile">Address</p>
                    <p className="dark-profile-text">
                      {currentUser?.address}
                    </p>
                  </div>
                </Col>
              </Row>
            </div>

            <button className="border-0 client-delet" onClick={() => {
              setIsDelete(true)
            }}>
              <img src={circleredclose} className="me-2 " alt="" />Delete Account
            </button>
          </Col>
        </Row>
      </div>

      <Offcanvas
        show={show}
        onHide={handleClose}
        backdrop="static"
        placement="end"
      >
        <Offcanvas.Header closeButton></Offcanvas.Header>

        <Offcanvas.Body className="p-20">
          <EditProfileForm user={currentUser} setUser={setCurrentUser} handleClose={handleClose} />
        </Offcanvas.Body>
      </Offcanvas>
      <DeleteAccount show={isDelete} handleClose={() => { setIsDelete(false) }} />

    </div>
  );
};

export default ClientProfile;
